import React, { useState } from 'react'
import MenuIcon from "../../../../assets/images/menu_icon.svg";
import MenuModal from "./MenuModal.jsx";

const ShowMenu = () => {

    const [showModal, setShowModal] = useState(false);


    return (
        <div >
            <img src={MenuIcon} alt="" onClick={() => setShowModal(true)} />
            {
                showModal &&
                <MenuModal closeModal={() => setShowModal(false)} />
            }
        </div>
    )
}

export default ShowMenu